export default "__VITE_ASSET__BQW1leqL__"